import { walkPageNodes } from "../../../shared/src/page-tree";
import type { PageNode } from "../../../shared/src/pages";

// Lazy page elements (components/league/lazy-league.ts and lazy-widgets.ts) add how to find
// theirs here as they load; the root route loads them before any page does. This module stays
// free of React, so data code that private Workers share (server/document.server.ts) can call it.

type Part = { ready: () => Promise<unknown> };
const finders: ((node: PageNode) => Part | undefined)[] = [];

export function addLazyParts(find: (node: PageNode) => Part | undefined) {
  finders.push(find);
}

/**
 * Loads the lazy elements a page and the components it draws show, before it renders: on the
 * server so its HTML is whole, in the browser so a page it opens draws them at once.
 */
export async function readyPageNodes(
  document: { nodes: PageNode[] },
  components: Record<string, { nodes: PageNode[] }> = {},
): Promise<void> {
  const nodes = [document, ...Object.values(components)].flatMap(walkPageNodes);
  const needed = nodes.flatMap((node) => finders.map((find) => find(node)));
  await Promise.all([...new Set(needed)].map((part) => part?.ready()));
}
